module.exports = __webpack_public_path__ + "img/step-06-whatsapp.27f6ff1e.svg";